var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChecklist(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.625 6.72H4.56L3 5.145L4.065 4.095L5.1 5.115L7.215 3L8.28 4.065L5.625 6.72ZM10.485 4.5H22.485V6H10.485V4.5ZM10.485 9H22.485V10.5H10.485V9ZM22.485 13.5H10.485V15H22.485V13.5ZM10.485 18H22.485V19.5H10.485V18ZM4.56 11.22H5.625L8.28 8.565L7.215 7.515L5.1 9.63L4.065 8.595L3 9.66L4.56 11.22ZM5.625 15.735H4.56L3 14.175L4.065 13.11L5.1 14.145L7.215 12.015L8.28 13.08L5.625 15.735ZM4.56 20.25H5.625L8.28 17.595L7.215 16.53L5.1 18.66L4.065 17.625L3 18.675L4.56 20.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklist);
export default __webpack_public_path__ + "static/media/Checklist.07e0558df66e56dbaba680c9d9e95612.svg";
export { ForwardRef as ReactComponent };